import { render, staticRenderFns } from "./ShopTheLookSlider.vue?vue&type=template&id=1246177c&"
import script from "./ShopTheLookSlider.vue?vue&type=script&lang=js&"
export * from "./ShopTheLookSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockSlider2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BlockSlider2.vue').default})
